<template>
  <div>
    <slot :src="{ src }">
    </slot>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  mounted() {
    this.getSignedUrl();
  },
  props: {
    location: {
      type: String,
      required: true,
    },
    expireTime: {
      type: Number,
      default: 480,
    },
    url: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      src: {},
    }
  },
  methods: {
    getSignedUrl() {
      this.axios.get(this.url, {
        params: {
          key: this.location,
          expireTime: this.expireTime,
          ...this.params,
        },
      }).then(({ data }) => {
        this.src = data.signedUrl;
        this.$emit('loaded', this.src);
      }).catch((error)  => {
        this.$emit('loaded', null);
      });
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/global/FileStreamer/FileStreamer.vue